export default {
  title: 'Articles épuisés',
  sections: {
    settings: 'Paramètres',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset: 'Les articles épuisés sont automatiquement remis en disponible en fin de journée.',
        manual_reset: 'Le personnel doit marquer les articles comme disponibles après les avoir marqués comme épuisés.',
      },
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
